<app-card-wrapper [centered]="centered" [useMarginBottom]="useMarginBottom">
  <mat-card [ngClass]="{ 'no-card-shadow': !cardShadow }" [ngStyle]="{ margin: cardMargin }">
    <mat-card-header [ngStyle]="{ margin: headerMargin }" class="justify-space-between">
      <mat-card-title>
        @if (titleIcon) {
          <mat-icon class="with-text align-middle">{{ titleIcon }}</mat-icon>
        }
        {{ title | translate: locale.language }}
        <ng-content select=".title-extras"></ng-content>
      </mat-card-title>
      @if (!!subtitle) {
        <mat-card-subtitle>{{ subtitle | translate: locale.language }}</mat-card-subtitle>
      }
      <ng-content select=".card-header"></ng-content>
    </mat-card-header>
    @if (hasDivider) {
      <mat-divider></mat-divider>
    }
    <mat-card-actions>
      <ng-content select=".card-actions"></ng-content>
    </mat-card-actions>
    <mat-card-content class="balsa-card-content">
      <div class="balsa-card-loading-container" [style.min-height]="circleLoading ? 'inherit' : '4px'">
        <app-loading class="loading" [hasLoaded]="!loading" [isCircle]="circleLoading"></app-loading>
      </div>
      <div
        class="balsa-card-content-container"
        [style.max-height]="cardMaxHeightCalculation"
        [style.min-height]="minHeight">
        <ng-content select=".card-content"></ng-content>
      </div>
    </mat-card-content>
    <mat-card-footer style="margin-bottom: 1rem">
      <ng-content select=".card-footer"></ng-content>
    </mat-card-footer>
  </mat-card>
</app-card-wrapper>
